import { IPokeandPullRequest, IRequestedValues, ISheetValues, IWorkbookService, IWorkbookValues, WorkbookServiceResponse } from '../models/Workbook'
import { ServiceError, WebServiceBase, WebServiceResponse } from '../WebServiceBase'

// supply some error messages for our domains
ServiceError.domainCatalogs.Workbooks = {
  100: 'There are no free resources to handle this request'
}

class WorkbookService extends WebServiceBase implements IWorkbookService {
  protected apiEndpoint: string;

  constructor(protected serviceEndpoint: string, protected workbook: string) {
    super()
    this.apiEndpoint = this.serviceEndpoint + 'api/workbook/'
  }

  public exportExhibitTab(accessToken: string, requested: IPokeandPullRequest): Promise<WorkbookServiceResponse> {
    requested.workbook = this.workbook
    const uri = this.apiEndpoint + 'ExportExhibitTab';
    const req = this.requestOptions(uri, requested, accessToken, { method: 'POST' })
    // tslint:disable-next-line:no-console
    //console.log('pokeAndPull- uri: ' + uri + ', req: ' + JSON.stringify(req, undefined, 4))
    return fetch(req)
      .then((response) => response.json())
      .then(WorkbookServiceResponse.fromJSON)
      .then((fr: WorkbookServiceResponse) => {
        if (fr.IsError) { throw fr }
        // tslint:disable-next-line:no-console
        console.log('WorkbookService.pokeAndPull worked. ' + JSON.stringify(fr))
        return fr
      })
      .catch((reason) => {
        // tslint:disable-next-line:no-console
        console.log('WorkbookService.pokeAndPull failed. ' + JSON.stringify(reason))
        throw reason
      })
  }

  public pokeAndPull(accessToken: string, requested: IPokeandPullRequest): Promise<WorkbookServiceResponse> {
    requested.workbook = this.workbook
    const uri = this.apiEndpoint + 'PokeAndPull';
    const req = this.requestOptions(uri, requested, accessToken, { method: 'POST' })
    // tslint:disable-next-line:no-console
    //console.log('pokeAndPull- uri: ' + uri + ', req: ' + JSON.stringify(req, undefined, 4))
    return fetch(req)
      .then((response) => response.json())
      .then(WorkbookServiceResponse.fromJSON)
      .then((fr: WorkbookServiceResponse) => {
        if (fr.IsError) { throw fr }
        // tslint:disable-next-line:no-console
        //console.log('WorkbookService.pokeAndPull worked. ' + JSON.stringify(fr))
        return fr
      })
      .catch((reason) => {
        // tslint:disable-next-line:no-console
        console.log('WorkbookService.pokeAndPull failed. ' + JSON.stringify(reason))
        throw reason
      });
  }

  public toString(): string {
    return 'WorkbookService(endpoint: ' + this.apiEndpoint + ')'
  }
}

export {
  WorkbookService
}



// WEBPACK FOOTER //
// ./src/app/services/WorkbookService/index.ts